import { useDataChange } from 'Simple/Data'

export function useOnChange(props) {
  let change = useDataChange({
    context: 'event_action',
    path: 'data.req',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    let { headers, body_type, ...rest } = value.req

    headers = headers.reduce(
      (acc, { key, value }) => ({ ...acc, [key]: value }),
      {}
    )

    change({
      ...rest,
      headers,
    })
  }
}
